import { motion } from "framer-motion";
import { Utensils, Heart, Users } from "lucide-react";
import { IMG } from "./constants";

export default function About({ t }) {
  const features = [
    { key: "portions", icon: Utensils, title: t.about.feature1, desc: t.about.feature1Desc },
    { key: "kitchen", icon: Heart, title: t.about.feature2, desc: t.about.feature2Desc },
    { key: "service", icon: Users, title: t.about.feature3, desc: t.about.feature3Desc },
  ];

  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32 bg-paper overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.7 }}
            className="relative"
          >
            <div className="absolute -top-4 -left-4 w-32 h-32 bg-checkered-strong opacity-80 -z-10" />
            <div className="absolute -bottom-4 -right-4 w-40 h-40 bg-bn-primary -z-10" />
            <img
              src={IMG.about}
              alt="Bodegón table"
              className="w-full h-[500px] object-cover stamp-border"
            />
            <div className="absolute -bottom-6 left-6 bg-bn-bg border-2 border-bn-secondary px-5 py-3 shadow-lg">
              <p className="font-script text-2xl text-bn-primary leading-none">
                el más <span className="text-bn-secondary">grande</span>
              </p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.7 }}
          >
            <p className="font-body text-bn-primary text-sm uppercase tracking-[0.3em] mb-4">
              — {t.about.kicker}
            </p>
            <h2
              className="font-display text-bn-secondary text-4xl md:text-5xl lg:text-6xl leading-[1.05] mb-6"
              data-testid="about-title"
            >
              {t.about.title}
            </h2>
            <p className="font-script text-3xl text-bn-primary mb-6">
              {t.about.handwritten}
            </p>
            <p className="font-body text-bn-text-muted text-base md:text-lg leading-relaxed mb-5">
              {t.about.paragraph1}
            </p>
            <p className="font-body text-bn-text-muted text-base md:text-lg leading-relaxed mb-8">
              {t.about.paragraph2}
            </p>

            <div className="grid sm:grid-cols-3 gap-5">
              {features.map((f) => (
                <div
                  key={f.key}
                  data-testid={`about-feature-${f.key}`}
                  className="border-l-2 border-bn-primary pl-4"
                >
                  <f.icon className="text-bn-primary mb-2" size={24} />
                  <h4 className="font-display text-bn-secondary text-lg mb-1">{f.title}</h4>
                  <p className="font-body text-sm text-bn-text-muted">{f.desc}</p>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
